import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { StoreState } from '@ui/store/rootReducer';
import {
  Button,
  EditIcon,
  LeftSideMenu,
  LoadableContent,
} from '@ui/components';
import Regions from '../components/Regions';
import { storesSelectors } from '..';
import * as actions from '../services/actions';
import { Icon, Input, Modal } from 'antd';
import CreateEntity from './CreateEntity';
import { metaSelectors } from '@ui/store/meta';

const MapLabelForEdit = {
  country: 'Страну',
  city: 'город',
  region: 'область',
};

interface StateToProps {
  regions?: any[];
  country?: any;
  loading?: boolean;
  entities?: any;
}

interface DispatchToProps {
  onLoadCities?: (countryId: string) => void;
  onLoadStores?: (region: any) => void;
  editEntity?: (id: string, value: string, type: string) => void;
  removeEntity?: (id: string, type: string) => void;
  createEntity?: (entity: any) => void;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class StoresLeftSide extends React.PureComponent<Props> {
  static defautProps = {
    country: {},
    regions: [],
  };

  state = {
    isVisibleCreateStore: false,
    isVisibleEditEntity: false,
    isVisibleRemoveEntity: false,
    isVisibleCreateEntity: false,
    type: '',
    value: '',
    initValue: '',
    id: '',
    isOpenEditPanel: false,
  };

  componentDidMount(): void {
    const { match, onLoadCities } = this.props;

    const { countryId } = match.params as any;

    if (onLoadCities) onLoadCities(countryId);
  }

  handleOpenStores = (region: any) => {
    const { onLoadStores } = this.props;
    console.log(region);
    if (onLoadStores) onLoadStores(region);
  };

  handleOpenEditEntity = (id: string, value: string, type: string) => {
    console.log(id);
    this.setState({
      id,
      value,
      type,
      initValue: value,
      isVisibleEditEntity: true,
    });
  };

  handleOpenRemoveEntity = (id: string, value: string, type: string) => {
    this.setState({
      id,
      value,
      type,
      isVisibleRemoveEntity: true,
    });
  };

  handleCloseEditEntity = () => {
    this.setState({ id: '', value: '', type: '', isVisibleEditEntity: false });
  };

  handleCloseRemoveEntity = () => {
    this.setState({
      id: '',
      type: '',
      value: '',
      isVisibleRemoveEntity: false,
    });
  };

  handleEditEntity = () => {
    const { editEntity = () => null } = this.props;
    const { type, id, value, initValue } = this.state;
    if (value && value !== initValue) {
      editEntity(id, value, type);
      this.handleCloseEditEntity();
    }
  };

  handleRemoveEntity = () => {
    const { removeEntity = () => null } = this.props;
    const { type, id } = this.state;
    removeEntity(id, type);
    this.handleCloseRemoveEntity();
  };

  createFormRef = (formRef: any) => {
    this.formRef = formRef;
  };
  private formRef: any;

  setIsVisible = (isVisibleCreateEntity: boolean) => {
    this.setState({ isVisibleCreateEntity });
  };

  handleCreateEntity = (typeEntity: any) => {
    const { form } = this.formRef.props;

    form.validateFields((err: any, entity: any) => {
      const { createEntity = () => null } = this.props;
      if (err) {
        return;
      }

      createEntity({ typeEntity, entity });

      this.setIsVisible(false);
    });
  };

  setOpenEditPanel = () => {
    const { isOpenEditPanel } = this.state;
    this.setState({ isOpenEditPanel: !isOpenEditPanel });
  };

  render(): React.ReactNode {
    const {
      loading = false,
      country,
      regions = [],
      entities = {},
    } = this.props;

    const {
      type,
      value,
      isVisibleEditEntity,
      isVisibleRemoveEntity,
      isVisibleCreateEntity,
      isOpenEditPanel,
    } = this.state;

    return (
      <LoadableContent loading={loading}>
        <LeftSideMenu
          topPanel={
            <div className="country-panel">
              <span>{country.name}</span>
              {isOpenEditPanel && (
                <div className="country-panel__edit">
                  <EditIcon
                    onClick={() =>
                      this.handleOpenEditEntity(
                        country.id,
                        country.name,
                        'country',
                      )
                    }
                    type="edit"
                  />
                  <EditIcon
                    type="remove"
                    onClick={() =>
                      this.handleOpenRemoveEntity(
                        country.id,
                        country.name,
                        'country',
                      )
                    }
                  />
                </div>
              )}
              <Icon
                type={isOpenEditPanel ? 'caret-left' : 'caret-right'}
                style={{
                  backgroundColor: 'black',
                  color: 'white',
                  width: '70px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}
                onClick={this.setOpenEditPanel}
              />
            </div>
          }
          bottomPanel={
            <Button
              size={'large'}
              className="create-store"
              type="primary"
              onClick={() => this.setIsVisible(true)}
            >
              <Icon type="plus" />
              Добавить город
            </Button>
          }
        >
          <Regions
            regions={regions}
            onClick={this.handleOpenStores}
            onOpenEditEntity={this.handleOpenEditEntity}
            onOpenRemoveEntity={this.handleOpenRemoveEntity}
            isOpenEditPanel={isOpenEditPanel}
          />
        </LeftSideMenu>
        <Modal
          okButtonProps={{
            style: {
              width: '120px',
            },
            size: 'large',
          }}
          cancelButtonProps={{
            style: {
              width: '120px',
            },
            size: 'large',
          }}
          onOk={this.handleEditEntity}
          visible={isVisibleEditEntity}
          onCancel={this.handleCloseEditEntity}
          okText="Сохранить"
          cancelText="Отмена"
        >
          <p>Редактировать {MapLabelForEdit[type]} </p>
          <Input
            value={value}
            onChange={event => this.setState({ value: event.target.value })}
          />
        </Modal>
        <Modal
          okButtonProps={{
            style: {
              width: '120px',
            },
            size: 'large',
            type: 'danger',
          }}
          cancelButtonProps={{
            style: {
              width: '120px',
            },
            size: 'large',
            type: 'primary',
          }}
          onOk={this.handleRemoveEntity}
          visible={isVisibleRemoveEntity}
          onCancel={this.handleCloseRemoveEntity}
          okText="Да"
          cancelText="Нет"
        >
          <div className="modal-remove-text">
            <p>Вы уверены что хотите удалить? </p>
            <h1>{MapLabelForEdit[type]}</h1>
            <h2>{value}</h2>
          </div>
        </Modal>
        <CreateEntity
          // @ts-ignore
          isVisible={isVisibleCreateEntity}
          wrappedComponentRef={this.createFormRef}
          onCreate={this.handleCreateEntity}
          onCancel={() => this.setIsVisible(false)}
          entities={entities}
        />
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  regions: storesSelectors.getRegions(state),
  country: storesSelectors.getCountry(state),
  loading: storesSelectors.getCitiesLoading(state),
  entities: metaSelectors.getAllEntities(state),
});

const mapDispatchToProps: DispatchToProps = {
  onLoadCities: actions.citiesRequested,
  onLoadStores: actions.storesRequested,
  editEntity: actions.editEntityRequested,
  removeEntity: actions.removeEntityRequested,
  createEntity: actions.createEntityRequested,
};

export default withRouter(
  connect<StateToProps, DispatchToProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(StoresLeftSide),
);



// WEBPACK FOOTER //
// ./src/scenes/Stores/containers/StoresLeftSide.tsx